export default "__VITE_ASSET__3141571a__"